<template>
    <div class="nav-tabs_parent">
        <ul class="nav nav-tabs float-left" id="navbar-list">
            <li class="nav-item" :class="{active: getTabSelected.tabIndex === key}" v-for="(tab,key) in tabs" :key="key">
                <a href="#" class="nav-link" @click="selectTabMethod(key)">
                    {{tab.type}}
                </a>
            </li>
        </ul>
    </div>
</template>

<script>

import { mapState, mapGetters, mapActions } from 'vuex';

export default {
    data:function(){
        return {
            tabs:[{tabIndex:0,type:'Spot',link:"/manageOffers/spot"},{tabIndex:1,type:'Contracts', link:"/manageOffers/contract"},{tabIndex:2,type:'Delivered In',link:"/manageOffers/deliveredIn"}]
        }
    },
    created() {
        this.getDinTerminals()
        this.getOffersTimeAvailability().then(()=>{     
            if (this.$router.history.current.params.tab==="spot"){
                this.selectTab(this.tabs[0])
            }else if (this.$router.history.current.params.tab==="contract"){
                this.selectTab(this.tabs[1])
            }else if (this.$router.history.current.params.tab==="deliveredIn"){
                this.selectTab(this.tabs[2])
            } 
        })
    },
    computed: {
        ...mapGetters('sellerTabs', ['getTabSelected']),
    },
    methods:{
        ...mapActions('sellerTabs',['selectTab']),
        ...mapActions('sellerOffers', ['getOffersTimeAvailability', 'getAllOffersForUser', 'getDinTerminals']),

        selectTabMethod(tabkey){
            event.preventDefault()
            this.$router.push(this.tabs[tabkey].link)
            this.selectTab(this.tabs[tabkey])
        }
    }
    
}
</script>
